import React from "react";
import { motion } from "framer-motion";

const PILLARS = [
  { icon: "fa-book", label: "Book" },
  { icon: "fa-graduation-cap", label: "Curriculum" },
  { icon: "fa-microphone-lines", label: "Speaking" },
  { icon: "fa-people-group", label: "Mentorship" },
  { icon: "fa-handshake-angle", label: "Brotherhood" },
  { icon: "fa-compass", label: "Mindset" }
];

export default function AboutMovement() {
  return (
    <section id="movement" data-testid="about-movement" className="relative overflow-hidden bg-ink-900 py-28 md:py-36">
      <div className="pointer-events-none absolute inset-0 bg-grain opacity-30 mix-blend-overlay" />
      <div className="mx-auto grid max-w-7xl gap-16 px-6 md:px-12 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <div className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/60" />
            About The Movement
          </div>
          <h2 className="font-display text-4xl font-bold leading-[1.05] text-white md:text-5xl lg:text-6xl">
            This isn't pretending life is easy.
            <span className="block text-gradient-gold">It's learning not to crash out when it gets hard.</span>
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-zinc-300">
            CA$H OUT NEVER CRASH OUT is more than a book. It's a leadership philosophy,
            a youth empowerment curriculum, a mentorship initiative, an apparel movement,
            and a speaking platform — built to help young people convert pain into purpose
            and noise into legacy.
          </p>
          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="#book"
              data-testid="about-cta-book"
              className="btn-gold rounded-full px-6 py-3 text-xs font-semibold uppercase tracking-wider"
            >
              Read The Book
            </a>
            <a
              href="#curriculum"
              data-testid="about-cta-curriculum"
              className="btn-ghost-gold rounded-full px-6 py-3 text-xs font-semibold uppercase tracking-wider"
            >
              Explore Curriculum
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
            {PILLARS.map((p, i) => (
              <motion.div
                key={p.label}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 + i * 0.06 }}
                className="group relative overflow-hidden rounded-2xl border border-white/5 bg-ink-700/70 p-6 transition-all hover:border-gold/40"
              >
                <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-gold/5 blur-2xl transition-opacity group-hover:opacity-80" />
                <i className={`fa-solid ${p.icon} text-2xl text-gold`} />
                <div className="mt-6 font-display text-xl text-white">{p.label}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-zinc-500">
                  Pillar 0{i + 1}
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mt-10 rounded-2xl border border-gold/20 bg-gradient-to-br from-ink-700/80 to-ink-900/80 p-8 md:p-10">
            <div className="flex items-start gap-5">
              <i className="fa-solid fa-quote-left mt-1 text-3xl text-gold" />
              <div>
                <p className="font-display text-2xl italic leading-snug text-white md:text-3xl">
                  "How brokenness became blueprint."
                </p>
                <p className="mt-3 text-sm uppercase tracking-[0.25em] text-zinc-400">
                  — Damien Doran, Mr. Green Bay
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
